import styled from "react-emotion";
import { useState } from "react";

const FormFieldContainer = styled("div")`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-left: ${(props) => (props.hideLabel ? "0px" : "15px")};
`;

const Label = styled("label")`
  width: 20%;
  display: ${(props) => (props.hideLabel ? "none" : "block")};
  min-width: 70px;
  padding: 15px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1rem;
  text-align: left;
  font-weight: 500;
  line-height: 1.5;
  margin-bottom: 0.375rem;
`;

const Input = styled("input")`
  font-size: 16px;
  width: 100%;
  padding: 11px 15px 11px 8px;
  animation: 1ms void-animation-out;
`;

const FormField = ({
  label,
  type,
  name,
  placeholder,
  required,
  value,
  hideLabel,
  onChangeCustom,
}) => {
  const [inputValue, setInputValue] = useState(value);

  const onChangeHandler = (event) => {
    if (onChangeCustom) {
      setInputValue(event.target.value);
      onChangeCustom(event.target.value);
    } else {
      setInputValue(event.target.value);
    }
  };
  return (
    <FormFieldContainer hideLabel={hideLabel}>
      <Label htmlFor={name} hideLabel={hideLabel}>
        {label}
      </Label>
      <Input
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
        value={inputValue}
        onChange={onChangeHandler}
        hideLabel={hideLabel}
      />
    </FormFieldContainer>
  );
};

export default FormField;
